import { FC } from 'react';
import Layout from 'src/components/Layout';
import Navbar from 'src/components/NavBar';
import SelectACompanyPlaceholder from 'src/components/SelectACompanyPlaceholder';
import ScanManagerContextProvider from 'src/sections/scan_manager/ScanManagerContext';
import ScanManagerHeader from 'src/sections/scan_manager/ScanManagerHeader';
import ScanManagerSplitter from 'src/sections/scan_manager/ScanManagerSplitter';

interface ScanManagerProps {
  isInvoices: boolean;
}

const ScanManager: FC<ScanManagerProps> = ({ isInvoices }) => (
  <ScanManagerContextProvider isInvoices={isInvoices}>
    <Navbar title="Scan Manager" />
    <Layout>
      <ScanManagerHeader />
      <SelectACompanyPlaceholder display={<ScanManagerSplitter />} />
    </Layout>
  </ScanManagerContextProvider>
);

export default ScanManager;
